/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx } from '@emotion/core';
import style from './TopBar.style';
/**
 * This component represents a navBar.
 * @param {*} children What will be shown inside the nav.
 * @param {*} className Used to load predetermine styles to the div that contains the nav.
 */

const Navbar = /*#__PURE__*/React.memo(({
  children,
  className
}) => {
  return jsx("div", {
    css: style,
    className: className
  }, jsx("nav", {
    className: "nav"
  }, children));
});
/**
 * This component represents a NavbarGroup.
 * @param {*} children What will be shown inside the NavbarGroup.
 * @param {string} align Align type.
 */

const NavbarGroup = /*#__PURE__*/React.memo(({
  children,
  align
}) => {
  let className = 'nav-group';

  if (align) {
    className += ` ${align}`;
  }

  return jsx("div", {
    className: className
  }, children);
});
/**
 * This component represents a Navbar link.
 * @param {*} children Link text.
 * @param {Function} onClick Triggered when click on the link
 */

const NavbarLink = /*#__PURE__*/React.memo(({
  children,
  onClick
}) => {
  return jsx("div", {
    className: "nav-link"
  }, jsx("a", {
    className: "link",
    onClick: onClick,
    role: "link",
    tabIndex: "0"
  }, children));
}, ({
  children,
  ...prevProps
}, {
  children: children2,
  ...nextProps
}) => JSON.stringify(prevProps) === JSON.stringify(nextProps));
/**
 * This component represents a divider.
 * @param {*} children Divider text.
 * @param {JSON} containerStyle Custom span styles.
 */

const NavbarDivider = ({
  children,
  containerStyle
}) => jsx("span", {
  className: "nav-link-divider",
  style: { ...containerStyle
  }
}, children);
/**
 * This component represents a NavbarLogo.
 * @param {*} children Logo image.
 */


const NavbarLogo = /*#__PURE__*/React.memo(({
  children
}) => {
  return jsx("figure", null, children);
}, () => true);
export { Navbar, NavbarGroup, NavbarDivider, NavbarLogo, NavbarLink };